import { workflowApi } from '@/services';

export default workflowApi;
